/* eslint-disable jira/import-whitelist */
import { fg } from '@atlassian/jira-feature-gating';
import { topNav4UIStateResource } from '@jira/navigation-apps__resources/src/services/top-nav/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import { navPlatformSidebarResource } from '@jira/nav-platform-integration__resources/src/navPlatformSidebarResource.tsx';
import { navPlatformRootStateResource } from '@jira/platform__controllers-layout/src/controllers/layout-controller/containers/layout-manager/navPlatformRootStateResource.tsx';
import { navigationUiStateResource } from '@jira/router-resources__navigation-ui-state/src/navigationUiStateResource.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { csmAppSidebarQueryResource } from './csmAppSidebarQueryResource.tsx';

// Loads classic Jira navigation UI state while Global Side Nav is disabled.
const conditionalNavigationUiStateResource = resourceWithCondition(
	() => !fg('navx-global-side-nav'),
	navigationUiStateResource,
);

// Loads the Global Side Nav root layout state when Global Side Nav is enabled.
const conditionalNavPlatformRootStateResource = resourceWithCondition(
	() => fg('navx-global-side-nav'),
	navPlatformRootStateResource,
);

// Loads the Global Side Nav sidebar state when Global Side Nav is enabled.
const conditionalNavPlatformSidebarResource = resourceWithCondition(
	() => fg('navx-global-side-nav'),
	navPlatformSidebarResource,
);

export function getCustomerServiceL1NavigationResources(): RouteResource[] {
	return [
		// Loads the baseline SPA shell resources required by Jira routes.
		...jiraSpaResources(),

		// Top navigation
		topNav4UIStateResource,

		// Left navigation
		csmAppSidebarQueryResource,

		// Loads the Nav4 sidebar entry UI state for sidebar selection/rendering.
		conditionalNavigationUiStateResource, // ? not needed???
		conditionalNavPlatformRootStateResource, // ?
		conditionalNavPlatformSidebarResource, // ?
	];
}
